export default function ValidateGDPRDisclaimer(GDPRDisclaimer) {
  var valid = true;
  var label = GDPRDisclaimer.siblings("label");
  label.removeClass("error");
  if (!GDPRDisclaimer.is(":checked")) {
    valid = false;
    label.addClass("error");
  }
  return valid;
}